import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import HtmlViewer from 'components/HtmlViewer';

export default function ResearchContributions({ data }) {
  // #region Data
  const { t } = useTranslation();
  // #endregion

  return (
    <div className="mt-3">
      <h4>{t('projectProposal.researchResult.researchContributions.label')}</h4>
      <div className="mt-3">
        <h4>
          {t('projectProposal.researchResult.researchContributions.contributionAndResolution')}
        </h4>
        <p className="font-italic">
          {t('projectProposal.researchResult.researchContributions.contributionAndResolutionNote')}
        </p>
        <HtmlViewer
          html={data?.knowledgeContributionLevel ?? ''}
          className="border border-1 border-gray-300 p-4 border-round-lg bg-white"
        />
      </div>

      <div className="mt-3">
        <h4>{t('projectProposal.researchResult.researchContributions.practicalImpact')}</h4>
        <p className="font-italic">
          {t('projectProposal.researchResult.researchContributions.practicalImpactNote')}
        </p>
        <HtmlViewer
          html={data?.practicalPolicyImpact ?? ''}
          className="border border-1 border-gray-300 p-4 border-round-lg bg-white"
        />
      </div>

      <div className="mt-3">
        <h4 className="mb-0">
          {t('projectProposal.researchResult.researchContributions.researchGroupDevelopment.label')}
        </h4>
        <p className="font-italic">
          {t('projectProposal.researchResult.researchContributions.researchGroupDevelopment.note')}
        </p>
        <HtmlViewer
          html={data?.teamDevelopmentLevel ?? ''}
          className="border border-1 border-gray-300 p-4 border-round-lg bg-white"
        />
      </div>

      <div className="mt-3">
        <h4 className="mb-0">
          {t(
            'projectProposal.researchResult.researchContributions.abilityTransferResearchResults.label'
          )}
        </h4>
        <p className="font-italic">
          {t(
            'projectProposal.researchResult.researchContributions.abilityTransferResearchResults.note'
          )}
        </p>
        <HtmlViewer
          html={data?.researchTransferability ?? ''}
          className="border border-1 border-gray-300 p-4 border-round-lg bg-white"
        />
      </div>
    </div>
  );
}

ResearchContributions.propTypes = {
  data: PropTypes.shape(),
};

ResearchContributions.defaultProps = {
  data: {},
};
